import React from "react";
import "./ThreadPanel.css";

export default function ThreadTypingIndicator({ users }) {
  if (!users || users.size === 0) return null;

  const userNames = Array.from(users).map((u) => u.userName);
  let text = "";

  if (userNames.length === 1) {
    text = `${userNames[0]} is typing...`;
  } else if (userNames.length === 2) {
    text = `${userNames[0]} and ${userNames[1]} are typing...`;
  } else {
    text = `${userNames[0]} and ${userNames.length - 1} others are typing...`;
  }

  return (
    <div className="thread-typing-indicator">
      <span className="thread-typing-dots">
        <span></span>
        <span></span>
        <span></span>
      </span>
      <span className="thread-typing-text">{text}</span>
    </div>
  );
}
